import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RandselMetal = _resolveComponent("RandselMetal")!
  const _component_RandselTransparent = _resolveComponent("RandselTransparent")!
  const _component_ThreeRandselBody = _resolveComponent("ThreeRandselBody")!
  const _component_ThreeRandselEdge = _resolveComponent("ThreeRandselEdge")!
  const _component_ThreeRandselThread = _resolveComponent("ThreeRandselThread")!
  const _component_ThreeRandselInside = _resolveComponent("ThreeRandselInside")!
  const _component_ThreeRandselPocket = _resolveComponent("ThreeRandselPocket")!
  const _component_ThreeRandselSide = _resolveComponent("ThreeRandselSide")!
  const _component_ThreeRandselFront = _resolveComponent("ThreeRandselFront")!
  const _component_ThreeRandselTack = _resolveComponent("ThreeRandselTack")!
  const _component_ThreeRandselBack = _resolveComponent("ThreeRandselBack")!
  const _component_ThreeRandselName = _resolveComponent("ThreeRandselName")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_RandselMetal),
    _createVNode(_component_RandselTransparent),
    _createVNode(_component_ThreeRandselBody),
    _createVNode(_component_ThreeRandselEdge),
    _createVNode(_component_ThreeRandselThread),
    _createVNode(_component_ThreeRandselInside),
    _createVNode(_component_ThreeRandselPocket),
    _createVNode(_component_ThreeRandselSide),
    _createVNode(_component_ThreeRandselFront),
    _createVNode(_component_ThreeRandselTack),
    _createVNode(_component_ThreeRandselBack),
    _createVNode(_component_ThreeRandselName)
  ]))
}